export const getFormattedData = (data, isReport = false) => {
  const cities = Object.keys(data.cities ?? {})
    .map((index) => ({
      label: index,
      value: data.cities[index],
    }))
    .filter((item) => Boolean(item.label));

  const countries = Object.keys(data.countries ?? {})
    .map((index) => ({
      label: data.countries[index].name,
      value: data.countries[index].total,
      code: index,
    }))
    .filter((item) => Boolean(item.label));

  const hours = completeHours(
    Object.keys(data.unique_viewers_per_hour ?? {})
      .map((index) => ({
        label: index,
        value: data.unique_viewers_per_hour[index],
      }))
      .sort((a, b) => (a.label > b.label ? 1 : -1)),
    isReport
  );

  const viewers_peak = data.unique_viewers_per_hour
    ? Object.keys(data.unique_viewers_per_hour).reduce(
        (accumulator, currentValue) => {
          if (data.unique_viewers_per_hour[currentValue] > accumulator) {
            return data.unique_viewers_per_hour[currentValue];
          }
          return accumulator;
        },
        0
      )
    : 0;

  const state_data = {
    total_viewers: data.uniques,
    average_time: data.playedTime / data.uniques,
    viewers_peak,
    cities,
    countries,
    hours,
  };

  if (isReport) {
    state_data.browsers = Object.keys(data.browser ?? {}).map((index) => ({
      label: index,
      value: data.browser[index],
    }));

    state_data.os = Object.keys(data.os ?? {}).map((index) => ({
      label: index,
      value: data.os[index],
    }));
  }

  return state_data;
};

const completeHours = (hours, getMaxValues = false) => {
  if (hours.length) {
    const offset = new Date()
      .toString()
      .match(/([-+][0-9]+)\s/)[1]
      .replace("-", ".")
      .replace("+", "-")
      .replace(".", "+");

    const labels = [];
    const data = [];

    let maxConcurrence = 0;
    let maxHour = "";

    const msHourValue = 3600000;

    let currentDate = new Date(`${hours[0].label}:00-00:00`);

    const addHours = (hours = 1) =>
      currentDate.setTime(currentDate.getTime() + msHourValue * hours);

    const pushLabel = (date) => {
      const tzDate = new Date(`${date}:00${offset}`);
      labels.push(tzDate.toISOString().substring(0, 13).replace("T", " "));
    };

    const emptyPush = () => {
      pushLabel(currentDate.toISOString().substring(0, 13).replace("T", " "));
      data.push(0);
    };

    addHours(-1);

    hours.forEach((hour) => {
      const hourDate = new Date(`${hour.label}:00-00:00`);

      while (currentDate.valueOf() !== hourDate.valueOf()) {
        emptyPush();
        addHours();
      }
      addHours();

      pushLabel(hour.label);
      data.push(hour.value);

      if (getMaxValues && hour.value > maxConcurrence) {
        maxConcurrence = hour.value;
        maxHour = hour.label;
      }
    });

    emptyPush();

    return { labels, data, maxConcurrence, maxHour };
  }

  return {};
};
